import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetModuleSubscriptionsErrorAction implements Action {
  public static readonly type = 'GetModuleSubscriptionsErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetModuleSubscriptionsErrorAction.type;
}
